import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types'
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

const Icon = <LoadingOutlined style={{ fontSize: 35 }} spin />

const Loading = (props) => {
  const {fallback} = props;
  const loader = useSelector(state => state.loader);


  if (!loader.loading && !fallback && !props.default) return  null;


  const { align, cover } = fallback ? props : loader;
  return (
    <div className={`loading text-${align} cover-${props.default ? 'overlay' : cover}`}>
      <Spin indicator={Icon} />
    </div>
  )
}

export default Loading